<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Editar Lote</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div v-if="plot" class="row justify-content-center">
        <card>
          <h3 slot="header" class="mb-0">Editar Lote: {{ plot.name }}</h3>

          <plot-form ref="plotForm" :plot="plot" :show-subtitle="false" />

          <base-button class="float-right" type="primary" @click="savePlot">Guardar</base-button>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import PlotForm from './Forms/PlotForm';
import swal from 'sweetalert2';

export default {
  components: {
    RouteBreadCrumb,
    PlotForm,
  },

  data() {
    return {
      plot: null,
    };
  },

  created() {
    const plotId = this.$route.params.id;
    this.fetchPlot(plotId);
  },

  methods: {
    async fetchPlot(plotId) {
      let params = {
        include: ['predecessor', 'variety.crop', 'campaign.crops', 'field', 'plotType', 'coordinates'],
      };

      const plot = await this.$services
        .resource('plots')
        .show(plotId, params)
        .then((res) => res.data.data);

      plot.crop = plot.variety.crop.id;
      plot.campaign = plot.campaign.id;
      plot.plotType = plot.plotType ? plot.plotType.id : null;
      plot.variety = plot.variety.id;
      plot.predecessor = plot.predecessor.id;
      this.plot = plot;
    },

    savePlot() {
      let data = Object.assign(this.plot, this.$refs.plotForm.get());
      this.$services
        .resource('plots')
        .update(this.plot.id, data)
        .then(() => {
          swal({
            title: 'Listo!',
            text: 'El lote fue actualizado.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success',
            type: 'success',
          }).then(() => this.$router.push({ name: 'PlotsList' }));
        });
    },
  },
};
</script>
